// CEOMessage.jsx
import React from 'react';
import './CEOMessage.css';

export default function CEOMessage() {

  return (
    <div className="ceo-container">
      <div className="ceo-section">
        {/* CEO Image Animation */}

        <div className="ceo-section-left">
        <div
          className="ceo-image-wrapper"
        >
          <img
            src="/images/ceo-image.png"
            alt="CEO"
            className="ceo-image"
            loading="lazy"
          />
        </div>
        </div>

        {/* CEO Content Animation */}
        <div 
          className="ceo-content"
        >
          <div>
          <h2 >CEO Message</h2>
          <p>
            "At Gladious Construction, we believe that every building tells a story. 
            For over two decades, we've been dedicated to creating structures that 
            stand the test of time while prioritizing sustainability, innovation, 
            and community impact."
          </p>
</div>
          <div className="ceo-signature">
            <p className="ceo-name">Hussain Mehmood</p>
            <p className="ceo-position">Founder & CEO</p>
          </div>
        </div>
      </div>
    </div>
  );
}
